import api from './api';

export interface User {
  id: number;
  cpf: string;
  email: string;
  name: string;
}

export interface Responsible {
  id: number;
  cpf: string;
  name: string;
  email?: string;
  phone?: string;
}

export interface Animal {
  id: number;
  name: string;
  species: string;
  breed?: string;
}

export interface Transfer {
  id: number;
  animal_id: number;
  animal?: Animal;
  from_user_id: number;
  from_user?: User;
  to_user_id: number;
  to_user?: User;
  from_responsible_id: number;
  from_responsible?: Responsible;
  to_responsible_id: number;
  to_responsible?: Responsible;
  transfer_date: string;
  created_at?: string;
  reason?: string;
  status: 'pending' | 'completed' | 'cancelled';
}

export interface CreateTransferData {
  animal_id: number;
  to_cpf: string;
  to_responsible_cpf: string;
  reason?: string;
}

export const transferService = {
  async getTransfers(): Promise<{ sent: Transfer[]; received: Transfer[] }> {
    const response = await api.get('/transfers');
    return response.data;
  },

  async getTransfer(id: number): Promise<Transfer> {
    const response = await api.get(`/transfers/${id}`);
    return response.data;
  },

  async createTransfer(data: CreateTransferData): Promise<Transfer> {
    const response = await api.post('/transfers', data);
    return response.data;
  },

  async approveTransfer(id: number): Promise<Transfer> {
    const response = await api.post(`/transfers/${id}/approve`);
    return response.data;
  },

  async cancelTransfer(id: number): Promise<Transfer> {
    const response = await api.post(`/transfers/${id}/cancel`);
    return response.data;
  },
};
